import React, { useEffect, useState } from "react";

import InfiniteScroll from "react-infinite-scroll-component";
import TimelinePostList from "components/TimelinePostList";
import Loader from "components/Loader";
import { TimelineContext } from "store/contexts/timelineContext";
import Button from "components/CustomButton";
import UserService from "services/UserService";
import PostModal from "components/TimelinePostList/TimelinePost/PostModal";
import { useUserContext } from "store/contexts/userContext";
import { TeamActionContext } from "store/contexts/teamActionContext";

export default () => {
  const [timeline, setTimeline] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState("");
  const [selectedPost, setSelectedPost] = useState(null);
  const [hide, setHide] = useState(false);
  const [publishId, setPublishId] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { user } = useUserContext();
  const LoaderStyle = {
    display: "flex",
    justifyContent: "center",
  };

  useEffect(() => {
    try {
      (async () => {
        const response = await UserService.getUserDashboard(page);

        setTimeline(Array.from(new Set([...timeline, ...response.data.data])));
        setTotal(response?.data?.meta?.total);
        setIsLoading(false);
      })();
    } catch (e) {
      console.log(e);
    }

    // eslint-disable-next-line
  }, [page]);

  const publishPost = (post = false, value = false) => {
    const timelineCopy = [...timeline];
    if (value && publishId) {
      timelineCopy[
        timelineCopy.findIndex((tPost) => {
          return tPost.id === publishId.post_id;
        })
      ].data = publishId;

      setTimeline(timelineCopy);
    }

    if (post) {
      setPublishId(post);

      timelineCopy[
        timelineCopy.findIndex((tPost) => {
          return tPost.id === post.post_id;
        })
      ].data = post;

      setTimeline(timelineCopy);
    }
  };

  const selectPost = (post) => {
    setSelectedPost(post);
  };

  const closeModal = () => {
    setSelectedPost(false);
  };

  const deletePost = (post) => {
    setTimeline(timeline.filter((timeline) => timeline.id !== post.id));
    decrementTotal();
  };

  const updatePost = (post) => {
    const timelineCopy = [...timeline];

    timelineCopy[
      timelineCopy.findIndex((tPost) => {
        return tPost.id === post.id;
      })
    ] = {
      ...post,
    };

    setTimeline(timelineCopy);
  };

  const getNextPageData = () => {
    setIsLoading(true);
    setPage(page + 1);
  };

  const createDashboardPost = (postData, postId, postUpdated, type) => {
    const newPost = {
      data: {
        ...postData,
      },
      team_id: teamId,
      type: type.name,
      updated_at: postUpdated,
      is_forwarded: false,
      buzz_type_id: null,
      buzzes_count: 0,
      content: "Initiated team todo list",
      current_user_buzz: null,
      expressions_count: 0,
      is_private: false,
      original_post: null,
      recent_buzz_activity_user: null,
      recent_expressed_activity_user: null,
      status_id: 1,
      type_id: type.id,
      user_expressed: false,
      id: postId,
      user: {
        ...user,
      },
    };

    createPost(newPost);
  };

  const createPost = (post) => {
    if (!post) {
      return;
    }

    setTimeline(Array.from(new Set([post, ...timeline])));

    incrementTotal();
  };

  const incrementTotal = () => {
    setTotal(total + 1);
  };

  const decrementTotal = () => {
    setTotal(total - 1);
  };

  const LoadingContainer = (
    <>
      {isLoading && (
        <h4>
          <Loader loaderStyle={LoaderStyle} />
        </h4>
      )}
      {!isLoading && (
        <h4>
          <Button color="warning" onClick={getNextPageData}>
            Load More
          </Button>
        </h4>
      )}
    </>
  );

  const clearAllData = () => {
    setTimeline([]);
    setTotal("");
    setPage(0);
  };

  const createNewPost = (postData, postId, postUpdated, type) => {
    const newPost = {
      data: {
        ...postData,
      },
      team_id: tmpTeamId.tmpTeamId,
      type: type.name,
      updated_at: postUpdated,
      is_forwarded: false,
      buzz_type_id: null,
      buzzes_count: 0,
      content: "Initiated team todo list",
      current_user_buzz: null,
      expressions_count: 0,
      is_private: false,
      original_post: null,
      recent_buzz_activity_user: null,
      recent_expressed_activity_user: null,
      status_id: 1,
      type_id: type.id,
      user_expressed: false,
      id: postId,
      user: {
        ...user,
      },
    };

    createPost(newPost);
  };

  return (
    <TeamActionContext.Provider value={{ createNewPost }}>
      <TimelineContext.Provider
        value={{
          createDashboardPost,
          deletePost,
          createPost,
          updatePost,
          publishPost,
          clearAllData,
          selectPost,
          setHide,
          selectedPost,
        }}
      >
        <div className="col-lg-6 middle-content px-3">
          <div className="mainRootContainer">
            <InfiniteScroll
              style={{
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
              dataLength={total ?? 0}
              next={getNextPageData}
              hasMore={timeline.length !== total}
              loader={LoadingContainer}
              scrollableTarget="main-panel-right"
              endMessage={
                <p style={{ textAlign: "center" }}>
                  {total > 0 && <b>Keep Engaging! </b>}
                </p>
              }
            >
              <TimelinePostList
                posts={timeline}
                total={total}
                setPage={setPage}
              />
            </InfiniteScroll>
          </div>
        </div>
        <PostModal
          hide={hide}
          post={selectedPost}
          open={selectedPost}
          close={closeModal}
        />
      </TimelineContext.Provider>
    </TeamActionContext.Provider>
  );
};
